import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

const Image = (props) => {

  const [Pic, setPic] = useState(props.src);

  useEffect(() => {
    if (props.isUrl) { //this if block runs if we got a web url for a image instead of local image url
      let img = props.src;

      const url = `${props.imgUrl}`;
      (async () => {
        const response = await axios({
          method: 'get',
          url: url,
        })
          .then(response => {
            const responsed = response.data;
            if (responsed.indexOf('Display File Error:') !== -1) {
              return false;
            }
            let b64Response = responsed.toString('base64');
            img = 'data:image/jpg;base64,' + b64Response;
            if (img) {
              setPic(img);
            }
            return responsed;
          })
          .catch(error => {
            const message = `An error has occured: ${error}`;
            throw new Error(message);
          });
        return response;
      })();
    }
  }, [props]);
  return (
    <img className={props.classes} src={props.isUrl ? Pic : props.src} alt={props.alt}
      style={{ cursor: props.cursor, height: props.height, width: props.width }} />
  );
};

export default Image;

Image.propTypes = {
  classes: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  cursor: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};